import { Button, Col, DatePicker, Form, Row, Skeleton, Space, Table } from 'antd';
import { Tabs } from "antd";
import withAuthorization from 'components/hocs/withAuthorization';
import PageWithFilters from 'components/page/page-with-filters';
import { PageWithFiltersContentContainer } from 'components/page/page.styles';
import { format } from 'date-fns';
import { Dayjs } from 'dayjs';
import useGetSettlements from 'hooks/data/useGetSettlements';
import useGetSettlementPayments from 'hooks/data/useGetSettlementPayments';
import React, { useState } from 'react';
import { RealmRoles, SettlementType } from '../../constants';
import useGetCsvFile from '../../hooks/useGetCsvFile';
import useToastContext from '../../hooks/useToastContext';
import { FaFileCsv } from '@react-icons/all-files/fa/FaFileCsv';
import SettlementTable from 'components/settlement/SettlementTable';
import { DateHelper } from '../../helper/date.helper';
const { RangePicker } = DatePicker;

type SettlementsFilterProps = {
  dateRanges: [Dayjs, Dayjs];
};

const SettlementsFilter = ({ onSubmit }: { onSubmit: (data: SettlementsFilterProps) => void }) => {
  const [form] = Form.useForm<SettlementsFilterProps>();

  const onFinish = (values: SettlementsFilterProps) => {
    onSubmit(values);
  }

  const onReset = () => {
    // @ts-ignore
    onSubmit({});
  }

  return (
    <Form
      form={form}
      initialValues={{ dateRanges: DateHelper.getDayJsLastMonthRange()}}
      name="advanced_search"
      onFinish={onFinish}
      onReset={onReset}
    >
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item<SettlementsFilterProps> name="dateRanges">
            <RangePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={8}></Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <Space>
            <Button type="primary" htmlType="submit">
              Buscar
            </Button>
            <Button htmlType="reset">Limpiar</Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

function getPreviousMonth(date = new Date()) {
  const previous = new Date(date.getTime());
  previous.setMonth(date.getMonth() - 1);

  return previous;
}

const Settlements = () => {
  const toast = useToastContext();
  const [filters, setFiltersDate] = useState({
    startDate: `${format(getPreviousMonth(), 'yyyy-MM-dd')}`,
    endDate: `${format(new Date(), 'yyyy-MM-dd')}`,
  });

  const { settlements, isLoadingSettlements } = useGetSettlements(
    filters.startDate,
    filters.endDate
  );

  const { payments, isLoadingSettlementPayments } = useGetSettlementPayments(
    filters.startDate,
    filters.endDate
  );

  const { fileUrl, fileLoading, execute } = useGetCsvFile(
    `v1/reports?report_type=SETTLEMENT&from_created_time=${filters?.startDate + 'T00:00:00Z'}&to_created_time=${filters?.endDate + 'T23:59:59Z'}`
  );

  const onSearchClick = (data: SettlementsFilterProps) => {
    setFiltersDate({
      startDate: data.dateRanges?.[0] ? `${format(data.dateRanges?.[0]?.toDate(), 'yyyy-MM-dd')}` : '',
      endDate: data.dateRanges?.[1] ? `${format(data.dateRanges?.[1]?.toDate(), 'yyyy-MM-dd')}` : '',
    });
  };

  const getCsvFile = async () => {
    if(filters?.startDate !== null && filters?.endDate !== null) {
      const response = await execute();

      if(response?.status === 200 || response?.status === 204) {
        window.open(response?.data?.url);
        toast.success('Exito', 'Transacciones exportadas correctamente!.');
      }else {
        toast.error('Error', 'Ocurrió un problema al exportar, porfavor, intenta nuevamente.')
      }
    }
  }


  const tabs = [
    {
      label: 'Domestico',
      key: '0',
      children: <SettlementTable settlements={settlements} payments={payments} type={SettlementType.DOMESTIC} loading={isLoadingSettlements} />,
    },
    {
      label: 'Internacional',
      key: '1',
      children: <SettlementTable settlements={settlements} payments={payments} type={SettlementType.INTERNATIONAL} loading={isLoadingSettlements} />,
    }
  ]

  return (
    <PageWithFilters title="Settlement">
      <PageWithFiltersContentContainer>
        <SettlementsFilter onSubmit={onSearchClick} />
      </PageWithFiltersContentContainer>
      <PageWithFiltersContentContainer>
        {
          isLoadingSettlements || isLoadingSettlementPayments ? (
            <Skeleton/>
          ):(
            <Tabs items={tabs} tabBarExtraContent={
              <Button
                type="primary"
                icon={ <FaFileCsv /> }
                disabled={ !(settlements?.length > 0) }
                loading={ fileLoading }
                onClick={ getCsvFile }
                size={'middle'}
              >
               Exportar
              </Button>
            }
            />
          )
        }

      </PageWithFiltersContentContainer>
    </PageWithFilters>
  );
};

export default withAuthorization([RealmRoles.BalanceSettlementRead], Settlements);
